import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'react-bootstrap';

import {
  build as constants,
  urls as urlHelpers
} from './../helpers';
import InstallerLinkContainer from './../Containers/InstallerLinkContainer';
import BuildFeedbackContainer from './../Containers/BuildFeedbackContainer';

const BuildInfoComponent = ({
  builds,
  baselines,
  isExpectedBaseline,
  isLatestByImage
}) => (
  <div>
    <Row>
      <Col md={12}>
        <BuildFeedbackContainer />
      </Col>
    </Row>
    <br />
    <Row>
      <Col md={12}>
        <fieldset>
          <legend>Current:</legend>
        </fieldset>
        {
          (builds.length) ?
            builds.map((b, i) => (
              <div key={i}>
                <Row>
                  <Col md={12}>
                    {constants.getBuildFriendlyName(b)}: {constants.getBuildVersion(b)}
                  </Col>
                </Row>
                <InstallerLinkContainer build={b} />
              </div>
            )) :
            (
              <Row>
                <Col md={12}>None</Col>
              </Row>
            )
        }
      </Col>
    </Row>
    <br />
    <Row>
      <Col md={12}>
        <fieldset>
          <legend>Baseline:</legend>
        </fieldset>
        {
          isExpectedBaseline ?
            <span>
              Jira: Expected Hits<br />
              <a href={`${urlHelpers.JIRA_BASE_URL}/projects/SCAN`}>SCAN Jira Project</a>
            </span> :
            isLatestByImage ?
              <span>Latest by Image</span> :
              baselines.length ?
                baselines.map((b, i) =>
                  (<div key={i}>
                    <Row>
                      <Col md={12}>
                        <span>
                          {
                            constants.getBuildFriendlyName(b) + ': ' +
                            constants.getBuildVersion(b)
                          }
                        </span>
                      </Col>
                    </Row>
                    <InstallerLinkContainer build={b} />
                  </div>)) :
                <Row><Col md={12}><span>None</span></Col></Row>
        }
      </Col>
    </Row>
  </div>
);

BuildInfoComponent.propTypes = {
  builds: PropTypes.array.isRequired,
  baselines: PropTypes.array.isRequired,
  isExpectedBaseline: PropTypes.bool,
  isLatestByImage: PropTypes.bool
};

export default BuildInfoComponent;


// WEBPACK FOOTER //
// src/Components/BuildInfoComponent.jsx